module.exports = __webpack_public_path__ + "img/setting-user.348df0b8.png";